export default __webpack_public_path__ + "static/media/pay_refund.ebdb7ffc.svg";